import React, { ReactNode } from "react";

type Props = {
  pageTitle: string;
  children: ReactNode;
  primaryAction?: ReactNode;
};
export default function PageLayout({
  pageTitle,
  children,
  primaryAction,
}: Props) {
  const renderPrimaryActions = () => {
    if (!primaryAction) {
      return null;
    }
    return <div className="flex justify-end w-full smallTablet:justify-start">{primaryAction}</div>;
  };

  return (
    <div className="bg-background min-h-screen p-8 smallTablet:p-4">
      <div className="flex w-full items-center smallTablet:flex-col smallTablet:items-start smallTablet:gap-3">
        {" "}
        <h1 className="text-[34px] font-dmSans font-bold text-nowrap capitalize smallTablet:text-[26px] smallTablet:text-wrap bg-gradient-heading bg-clip-text text-transparent">
          {pageTitle}
        </h1>
        {renderPrimaryActions()}
      </div>

      <div className="my-4  bg-inherit">{children}</div>
    </div>
  );
}
